import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";

function MaterialesLaboratorio() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [materiales, setMateriales] = useState([]);
    
    // Modal
    const [showModal, setShowModal] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [materialId, setMaterialId] = useState(null);
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [activo, setActivo] = useState(true);
    
    // Búsqueda
    const [busqueda, setBusqueda] = useState('');

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS
        let tienePermiso = false;
        
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionLaboratorio');
        } else if (userdata.up && userdata.up.includes('gestionLaboratorio')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        cargarMateriales();
    }, []);

    const cargarMateriales = () => {
        axios.get('/materiales-laboratorio')
            .then(response => {
                if (response.status === 200) {
                    setMateriales(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const abrirModalNuevo = () => {
        setModoEdicion(false);
        setMaterialId(null);
        setNombre('');
        setDescripcion('');
        setActivo(true);
        setShowModal(true);
    };

    const abrirModalEditar = (material) => {
        setModoEdicion(true);
        setMaterialId(material.id);
        setNombre(material.nombre);
        setDescripcion(material.descripcion || '');
        setActivo(material.activo === 1);
        setShowModal(true);
    };

    const cerrarModal = () => {
        setShowModal(false);
        setModoEdicion(false);
        setMaterialId(null);
        setNombre('');
        setDescripcion('');
        setActivo(true);
    };

    const guardarMaterial = async () => {
        if (!nombre.trim()) {
            alert('Por favor ingrese el nombre del material');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`/material-laboratorio/${materialId}`, {
                    nombre: nombre,
                    descripcion: descripcion,
                    activo: activo ? 1 : 0
                });
                alert('Material actualizado exitosamente');
            } else {
                await axios.post('/material-laboratorio', {
                    nombre: nombre,
                    descripcion: descripcion,
                    activo: activo ? 1 : 0
                });
                alert('Material creado exitosamente');
            }
            
            cerrarModal();
            cargarMateriales();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar: ' + (error.response?.data?.message || error.message));
        }
    };

    const eliminarMaterial = async (id, nombre) => {
        if (!window.confirm(`¿Está seguro de eliminar el material "${nombre}"?`)) {
            return;
        }

        try {
            await axios.delete(`/material-laboratorio/${id}`);
            alert('Material eliminado exitosamente');
            cargarMateriales();
        } catch (error) {
            console.error('Error al eliminar:', error);
            alert('Error al eliminar: ' + (error.response?.data?.message || error.message));
        }
    };

    const materialesFiltrados = materiales.filter(material =>
        material.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
        (material.descripcion && material.descripcion.toLowerCase().includes(busqueda.toLowerCase()))
    );

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="laboratory" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/laboratorio">Laboratorio</Link></li>
                                        <li className="breadcrumb-item">Materiales</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Materiales de Laboratorio</h1>
                                </div>
                                <div className="col-sm-4">
                                    <button 
                                        className="btn btn-warning float-right"
                                        onClick={abrirModalNuevo}
                                    >
                                        <i className="fas fa-plus"></i> Nuevo Material
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            {/* Barra de búsqueda */}
                            <div className="card card-warning card-outline">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group mb-0">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Buscar material..."
                                                    value={busqueda}
                                                    onChange={(e) => setBusqueda(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Tabla de materiales */}
                            <div className="card card-warning card-outline">
                                <div className="card-body p-0" style={{overflowX: 'auto'}}>
                                    <table className="table table-bordered table-hover" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th>Nombre</th>
                                                <th>Descripción</th>
                                                <th width="100">Estado</th>
                                                <th width="150">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {materialesFiltrados.map((material, index) => (
                                                <tr key={material.id}>
                                                    <td>{index + 1}</td>
                                                    <td><strong>{material.nombre}</strong></td>
                                                    <td>{material.descripcion || '-'}</td>
                                                    <td className="text-center">
                                                        {material.activo === 1 ? (
                                                            <span className="badge badge-success">Activo</span>
                                                        ) : (
                                                            <span className="badge badge-secondary">Inactivo</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        <button 
                                                            className="btn btn-sm btn-warning mr-1"
                                                            onClick={() => abrirModalEditar(material)}
                                                            title="Editar"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => eliminarMaterial(material.id, material.nombre)}
                                                            title="Eliminar"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {materialesFiltrados.length === 0 && (
                                        <div className="text-center p-4">
                                            <p>No se encontraron materiales.</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal */}
                {showModal && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header bg-warning text-white">
                                    <h4 className="modal-title">
                                        {modoEdicion ? 'Editar Material' : 'Nuevo Material'}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={cerrarModal}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label>Nombre *</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Ej: Porcelana, Metal, Zirconio..."
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Descripción</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            placeholder="Descripción opcional del material..."
                                            value={descripcion}
                                            onChange={(e) => setDescripcion(e.target.value)}
                                        ></textarea>
                                    </div>

                                    <div className="form-group">
                                        <div className="custom-control custom-switch">
                                            <input 
                                                type="checkbox" 
                                                className="custom-control-input" 
                                                id="switchActivo"
                                                checked={activo}
                                                onChange={(e) => setActivo(e.target.checked)}
                                            />
                                            <label className="custom-control-label" htmlFor="switchActivo">
                                                Activo
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                                        Cancelar
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-warning" 
                                        onClick={guardarMaterial}
                                        disabled={!nombre.trim()}
                                    >
                                        <i className="fas fa-save"></i> Guardar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default MaterialesLaboratorio;
